
const digest = 'ec110dc201cfef947305decc9e54d78a3627e81743d0908e3269d3549f529ff7';
const classes = {"attachmentButton":"_attachmentButton_xqhmg_1","icon":"_icon_xqhmg_8","remove":"_remove_xqhmg_12","title":"_title_xqhmg_16","additionalText":"_additionalText_xqhmg_22","actionButton":"_actionButton_xqhmg_28","disabledTitle":"_disabledTitle_xqhmg_47","iconRight":"_iconRight_xqhmg_55","button":"_button_xqhmg_59","green":"_green_xqhmg_72","blue":"_blue_xqhmg_76","red":"_red_xqhmg_80","disabled":"_disabled_xqhmg_47","badge":"_badge_xqhmg_90","skCircle":"_sk-circle_xqhmg_99","skChild":"_sk-child_xqhmg_99","linkButton":"_linkButton_xqhmg_103","smallButton":"_smallButton_xqhmg_125","fitContent":"_fitContent_xqhmg_167"};
const css = `._attachmentButton_xqhmg_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
._attachmentButton_xqhmg_1 ._icon_xqhmg_8 {
  width: 20px;
  height: 20px;
}
._attachmentButton_xqhmg_1 ._remove_xqhmg_12 {
  width: 15px;
  height: 15px;
}
._attachmentButton_xqhmg_1 ._title_xqhmg_16 {
  font-size: 14px;
  color: #1665d8;
  font-weight: 500;
  text-decoration: underline;
}
._attachmentButton_xqhmg_1 ._additionalText_xqhmg_22 {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

._actionButton_xqhmg_28 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: max-content;
}
._actionButton_xqhmg_28 ._icon_xqhmg_8 {
  width: 15px;
  height: 15px;
}
._actionButton_xqhmg_28 ._title_xqhmg_16 {
  font-size: 14px;
  color: #1665d8;
  font-weight: 500;
  text-decoration: underline;
  text-wrap: nowrap;
}
._actionButton_xqhmg_28 ._disabledTitle_xqhmg_47 {
  font-size: 14px;
  color: #737373;
  font-weight: 500;
  text-decoration: underline;
  cursor: not-allowed;
}

._iconRight_xqhmg_55 {
  flex-direction: row-reverse;
}

._button_xqhmg_59 {
  font-size: 14px;
  font-weight: 500;
  padding: 13px 24px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  border-radius: 21.5px;
  cursor: pointer;
  font-family: Rubik, "sans-serif";
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 10px;
}
._button_xqhmg_59._green_xqhmg_72 {
  background-color: #619612;
  color: #ffffff;
}
._button_xqhmg_59._blue_xqhmg_76 {
  background-color: #1665d8;
  color: #ffffff;
}
._button_xqhmg_59._red_xqhmg_80 {
  background-color: #d81616;
  color: #ffffff;
}
._button_xqhmg_59._disabled_xqhmg_47 {
  background-color: #737373;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.8;
}
._button_xqhmg_59 ._badge_xqhmg_90 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f12848;
}
._button_xqhmg_59 ._sk-circle_xqhmg_99 ._sk-child_xqhmg_99:before {
  background-color: #ffffff;
}

._linkButton_xqhmg_103 {
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  text-align: center;
}
._linkButton_xqhmg_103._blue_xqhmg_76 {
  color: #1665d8;
}
._linkButton_xqhmg_103._green_xqhmg_72 {
  color: #619612;
}
._linkButton_xqhmg_103._red_xqhmg_80 {
  color: #d81616;
}
._linkButton_xqhmg_103._disabled_xqhmg_47 {
  color: #737373;
  cursor: not-allowed;
}

._smallButton_xqhmg_125 {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  cursor: pointer;
  font-family: Rubik, "sans-serif";
  justify-content: center;
  display: flex;
}
._smallButton_xqhmg_125._green_xqhmg_72 {
  background-color: #619612;
  color: #ffffff;
}
._smallButton_xqhmg_125._blue_xqhmg_76 {
  background-color: #1665d8;
  color: #ffffff;
}
._smallButton_xqhmg_125._red_xqhmg_80 {
  background-color: #d81616;
  color: #ffffff;
}
._smallButton_xqhmg_125._disabled_xqhmg_47 {
  background-color: #737373;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.8;
}
._smallButton_xqhmg_125 ._badge_xqhmg_90 {
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f12848;
  display: flex;
  align-items: center;
  justify-content: center;
}

._fitContent_xqhmg_167 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  